import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const ViewCancellationModal = ({ isOpen, onClose, cancellationDetails, seriesNo }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300 ease-in-out">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md transform transition-all duration-300 scale-100 sm:scale-95">
        <div className="p-6 border-b border-gray-100">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold text-gray-800">
              Cancellation Details for Series: {seriesNo}
            </h2>
            <button
              onClick={onClose}
              className="text-gray-600 hover:text-garay-800 text-lg"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        </div>
        <div className="p-6">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Reason for Cancellation</label>
            {/* <p className="text-sm text-gray-600">{cancellationDetails?.reason || 'No reason provided'}</p> */}
            <textarea
                readOnly
                rows={8}
                value={cancellationDetails?.reason || 'No reason provided'}
                className="w-full text-sm text-gray-600 border border-gray-300 rounded-lg p-2 bg-gray-100 resize-none"
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Cancelled By</label>
            <p className="text-sm text-gray-600">{cancellationDetails?.cancelled_by || 'Unknown'}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Cancelled At</label>
            <p className="text-sm text-gray-600">{cancellationDetails?.cancelled_at || 'N/A'}</p>
          </div>
        </div>
        <div className="p-6 border-t border-gray-100 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewCancellationModal;